import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchFoundingImports } from "../../../../services/automapFoundingDealerApi";
import { FoundingShell } from "./AdminFoundingShared";

export default function AdminFoundingImportsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchFoundingImports()
      .then((data) => setRows(data.rows || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <FoundingShell active="imports" title="Tracker de importaciones" description="Inventario recibido, limpio y listo por dealer fundador.">
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error ? (
        <section className="dealer-state-box">
          {!rows.length ? (
            <p className="muted">Sin dealers convertidos con inventario aún.</p>
          ) : (
            <table className="dealer-inventory-table">
              <thead>
                <tr>
                  <th>Dealer</th>
                  <th>Activos</th>
                  <th>Importados</th>
                  <th>Sin fotos</th>
                  <th>Stale</th>
                  <th>Calidad</th>
                  <th>Estado</th>
                  <th>Siguiente acción</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.dealerId}>
                    <td>{row.dealerName}</td>
                    <td>{row.activeCount}</td>
                    <td>{row.importedCount}</td>
                    <td>{row.missingPhotoCount}</td>
                    <td>{row.staleCount}</td>
                    <td>{row.qualityScoreAverage ?? "—"}</td>
                    <td>{row.importStatus}</td>
                    <td>{row.nextAction}</td>
                    <td>
                      <Link to={`/admin/inventory/imports?dealerId=${row.dealerId}`}>Import</Link>
                      {" · "}
                      <Link to={`/admin/listings?dealerId=${row.dealerId}`}>Listings</Link>
                      {" · "}
                      <Link to={`/admin/inventory-quality/stale?dealerId=${row.dealerId}`}>Calidad</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>
      ) : null}
    </FoundingShell>
  );
}
